// extracted by mini-css-extract-plugin
export var divider = "_me-0";
export var systemMessage = "_me-1";
export var systemMessageWrapper = "_me-2";